// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__JjMGk","header":"ReportDetails_header__W1MR8","title":"ReportDetails_title__Bl0X4","left":"ReportDetails_left__341ou"};